import { cn } from "@/shared/lib/utils";

export const MaxWidthWrapper = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div className={cn("mx-auto w-full max-w-3xl px-2 md:px-4", className)}>
      {children}
    </div>
  );
};
